<template>
    <b-modal ref="modal" centered class="modal-removal">
        <template slot="modal-header">
            <h1>{{ Translations.sections.clocks.removal.title }} : {{ name }}</h1>
        </template>
        <template>
            <WaitingBlock v-if="modalState.isLoadingClock">
            </WaitingBlock>
            <div v-else class="modal-content-container">
                <div class="table-container">
                    <template v-if="!isRemovable">
                        <h2>
                            Clock not removable
                        </h2>
                        <div class="removal-warning-card" v-if="((clockData||{}).statistics||{}).dayTemplateCount > 0">
                            <i :class="['fas', 'fa-exclamation-circle']"></i>
                            {{ clockData.statistics.dayTemplateCount }} linked day templates
                        </div>
                    </template>
                    <div v-else>
                        <h2 class="modal-content-title">{{Translations.sections.clocks.removal.text}}</h2>
                    </div>
                </div>

                <div v-if="error" class="modal-content-row">
                    <div class="modal-content-col modal-content-col--full">
                        <span class="text-danger">{{ error === 'CLOCK_NOT_ELLIGIBLE_TO_REMOVAL' ? 'This clock can\'t be deleted' : 'Oops, an error occurs while deleting the clock'}}</span>
                    </div>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="hide">{{ Translations.buttons.cancel }}</Button>
            <div class="modal-footer-right">
                <div v-if="modalState.isRemoving" class="m-loader"></div>
                <Button :empty="false" :disabled="modalState.isRemoving" class="validate" v-if="isRemovable" @click.prevent="deleteClock">{{ Translations.buttons.doDeleteClock }} </Button>
                <Button :empty="false" class="validate" v-else="!isRemovable" @click.prevent="hide()">{{ Translations.buttons.close }} </Button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    // <script>
    /* eslint-disable */
    import Button from'@/components/common/Button';
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import router from '@/router';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import { HTTP } from '@/utils/http';
    import Apis from '@/apis/index'
    import { mapState } from 'vuex';
    import WaitingBlock from'@/components/common/WaitingBlock';

    export default {
        name: "ClockRemovalCard",
        store,
        components: { Bootstrap, Button, WaitingBlock },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            isRemovable() {
                return !this.modalState.hasLoadingError
                    && this.clockData != null
                    && this.clockData.statistics != null
                    && this.clockData.statistics.dayTemplateCount == 0;
            },
        },
        //created() {
        //    console.log("created")
        //    this.loadStatistics();
        //},
        //mounted() {
        //    console.log("mounted")
        //    this.loadStatistics();
        //},
        props: ['stationUid', 'clock', 'displayData'],
        watch: {
            'clock': function (to, from) {
                this.loadStatistics();
                if (!this.clock) {
                    this.name = null;
                    this.stats = null;
                    return;
                }
                // Reload Stats
                this.name = this.clock.name;
                this.stats = this.clock.statistics;
            }
        },
        data() {
            return {
                modalState: {
                    show: true,
                    visible: true,
                    isRemoving: false,
                    isLoadingClock: true,
                    isDeletingClock: false,
                    hasDeleteClock: false,
                    hasLoadingError: false,
                },
                name: this.clock ? this.clock.name : null,
                error: null,
                clockData: null
            }
        },
        methods: {
            show() {
                this.resetData();
                this.loadStatistics();
                this.$refs.modal.show();
            },
            hide() {
                this.resetData();
                this.$refs.modal.hide();
            },
            resetData() {
                this.error = null;
                this.modalState.isLoadingClock = true;
                this.modalState.isDeletingClock = this.modalState.hasDeleteError = this.modalState.hasLoadingError = false;
                this.deleteResponse = this.clockData = null;
            },
            async loadStatistics() {
                this.resetData();
                try {
                    if (this.currentStation != null && this.clock) {
                        this.modalState.isLoadingClock = true;
                        HTTP.post(Apis.clocks.removalData, { stationUid: this.currentStation.uid, clockUid: this.clock.uid })
                            .then(this.onDataLoaded, this.onDataLoadError)
                            .then(this.onDataLoadComplete);
                    }
                    else {
                        this.modalState.isLoadingClock = false;
                    }
                } catch (e) {
                    alert(e);
                    this.modalState.isLoadingClock = false;
                }
            },
            onDataLoaded(response) {
                var data = response.data.dataItem;
                this.clockData = data;
            },
            onDataLoadError(error) { this.modalState.hasLoadingError = true; this.clockData = error.response.data; },
            onDataLoadComplete(response) { this.modalState.isLoadingClock = false; },
            async deleteClock() {
                this.error = null;
                this.modalState.isRemoving = true;

                try {
                    const response = await HTTP.post(Apis.clocks.remove, {
                        stationUid: this.stationUid,
                        clockUid: this.clock.uid
                    });

                    this.modalState.isRemoving = false;
                    this.hide();
                    this.$emit('clockDeleted');
                } catch (e) {
                    const response = e.response.data;

                    if (response && response.errors && response.errors.length > 0) {
                        if (response.errors[0].message === 'CLOCK_NOT_ELLIGIBLE_TO_REMOVAL') {
                            this.error = response.errors[0].message;
                        } else {
                            this.error = e.message;
                        }
                    } else {
                        this.error = e.message;
                    }
                }

                this.modalState.isRemoving = false;
            }
        }
    }
</script>

<style>
</style>
